<template>
  <div
    class="modal fade addCartModal"
    id="addCartModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="addCartModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div v-if="lastAddedItem" class="modal-body my-row">
          <h3 class="mb-3 p-4 pb-0">Produkt byl přidán do košíku</h3>
          <div class="col-12-xs cart__wrapper__item_wrapper">
            <div class="cart__wrapper__item_wrapper__header">
              <img :src="imageSrc" alt="" />

              <div>
                <span class="cart__wrapper__item_wrapper__header__title">
                  {{ lastAddedItem?.name }}
                </span>
                <span>
                  {{ labelText(lastAddedItem) }}
                  {{ lastAddedItem?.variant ?? lastAddedItem?.color_name }}
                </span>
              </div>
            </div>

            <div class="cart__wrapper__item_wrapper__to_hide">
              <span>Cena</span>
            </div>

            <section>
              <div
                v-if="getLowestPrice().discounted"
                class="home__eshop__wrapper__price"
              >
                <span class="home__eshop__wrapper__price__trough">
                  {{ getLowestPrice().originalPrice }} Kč
                </span>
                <span class="home__eshop__wrapper__price__discount">
                  {{ getLowestPrice().price }} Kč
                </span>
              </div>

              <div v-else class="home__eshop__wrapper__price">
                <span>{{ getLowestPrice().price }} Kč</span>
              </div>
            </section>
          </div>

          <!-- ACTION BUTTONS -->
          <div class="modal-actions">
            <button class="btn btn-gray" @click="closeModal">
              Zpět do obchodu
            </button>
            <button class="btn btn-yellow" @click="goToCart">
              Pokračovat do košíku
            </button>
          </div>
        </div>

        <div v-else>Produkt byl přidán do košíku.</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from "bootstrap";

export default {
  name: "AddToCartModal",

  data() {
    return {
      imagesBasePath: `${process.env.VUE_APP_FITMO_BACKEND_URL}/products/`,
    };
  },

  computed: {
    lastAddedItem() {
      return this.$store.state.lastAddedItem;
    },

    imageSrc() {
      const p = this.lastAddedItem;
      if (!p) return "";

      if (p.color_name) {
        return (
          this.imagesBasePath +
          p.name +
          "-" +
          p.color_name +
          "/" +
          p.image_urls[0]
        );
      }

      if (p.variant) {
        return (
          this.imagesBasePath + p.name + "-" + p.variant + "/" + p.image_urls[0]
        );
      }

      return this.imagesBasePath + p.name + "/" + p.image_urls[0];
    },
  },

  methods: {
    labelText(product) {
      if (product?.color_name) return "Barva:";
      if (product?.variant) return "Varianta:";
      return "";
    },

    getLowestPrice() {
      if (!this.lastAddedItem) return { price: 0, discounted: false };

      if (this.lastAddedItem.discounted) {
        return {
          price: this.lastAddedItem.discounted,
          originalPrice: this.lastAddedItem.price,
          discounted: true,
        };
      }

      return {
        price: this.lastAddedItem.price,
        discounted: false,
      };
    },

    goToCart() {
      this.closeModal();
      this.$router.push("/objednavka/kosik");
    },

    showAddToCartModal() {
      const el = document.getElementById("addCartModal");
      if (!el) return;

      // stejné jako u deleteProductModal
      const modal = new bootstrap.Modal(el);
      modal.show();
    },

    closeModal() {
      const el = document.getElementById("addCartModal");
      if (!el) return;

      const modal = bootstrap.Modal.getInstance(el);
      if (modal) modal.hide();
    },
  },

  watch: {
    lastAddedItem(newVal, oldVal) {
      // otevřít jen pokud se opravdu přidal nový produkt
      if (newVal && newVal !== oldVal) {
        this.$nextTick(() => {
          this.showAddToCartModal();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.addCartModal .modal-body {
  padding: 2rem;

  & > * {
    width: 100%;
  }
}

a {
  text-decoration: none !important;

  span {
    font-size: 1.4rem;
    font-weight: 400;
    position: relative;

    &::before {
      content: "";
      display: block;
      position: absolute;
      bottom: 2px;
      left: 0%;
      transition: 0.2s ease width;
      height: 1px;
      background: $gray-second;
      width: 0%;
    }

    &:hover::before {
      width: 100%;
    }
  }
}

.cart__wrapper__item_wrapper {
  display: flex;
  gap: 1rem;

  &__header {
    span,
    a {
      width: 100%;
    }
  }
}

.modal-actions {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;

  button {
    flex: 1;
  }
}
</style>
